/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import { useDispatch, useSelector } from "react-redux";
import {
  createAssistant,
  updateAssistant,
} from "../../actions/assistantActions";
import { useSnackbar } from "react-simple-snackbar";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddAssistant = ({ setOpen, open, currentId, setCurrentId }) => {
  const location = useLocation();
  const [assistantData, setAssistantData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    userId: "",
    role: "assistant",
  });
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const dispatch = useDispatch();
  const assistant = useSelector((state) =>
    currentId
      ? state.assistants.assistants.find((c) => c._id === currentId)
      : null
  );
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();

  useEffect(() => {
    if (assistant) {
      setAssistantData({
        ...assistant,
        firstName: assistant.name.split(" ")[0],
        lastName: assistant.name.split(" ")[1],
        password: "",
      });
    }
  }, [assistant]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
    // setClientData({...clientData, userId: user?.result?._id})
  }, [location]);

  useEffect(() => {
    var checkId = user?.result?._id;
    if (checkId !== undefined) {
      setAssistantData({ ...assistantData, userId: [checkId] });
    } else {
      setAssistantData({ ...assistantData, userId: [user?.result?.googleId] });
    }
  }, [location]);

  const handleSubmitClient = (e) => {
    e.preventDefault();
    if (currentId) {
      dispatch(updateAssistant({ currentId, assistantData, openSnackbar }));
    } else {
      dispatch(createAssistant(assistantData, openSnackbar));
    }
    handleClose();
    clear();
  };

  const clear = () => {
    setAssistantData({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      userId: [],
      role: "assistant",
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
  };

  return (
    <div>
      <form>
        <Dialog
          onClose={(e, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{ paddingLeft: "20px", color: "white" }}
          >
            {currentId ? "Edit Product" : "Add new Assistant"}
          </DialogTitle>
          <DialogContent dividers>
            <div className="customInputs">
              <input
                placeholder="First Name"
                style={inputStyle}
                name="firstName"
                type="text"
                onChange={(e) =>
                  setAssistantData({
                    ...assistantData,
                    firstName: e.target.value,
                  })
                }
                value={assistantData.firstName}
              />
              <input
                placeholder="Last Name"
                style={inputStyle}
                name="lastName"
                type="text"
                onChange={(e) =>
                  setAssistantData({
                    ...assistantData,
                    lastName: e.target.value,
                  })
                }
                value={assistantData.lastName}
              />
              <input
                placeholder="Email"
                style={inputStyle}
                name="email"
                type="text"
                onChange={(e) =>
                  setAssistantData({
                    ...assistantData,
                    email: e.target.value,
                  })
                }
                value={assistantData.email}
              />

              <input
                placeholder="Password"
                style={inputStyle}
                name="password"
                type="password"
                onChange={(e) =>
                  setAssistantData({
                    ...assistantData,
                    password: e.target.value,
                  })
                }
                value={assistantData.password}
              />
              <input
                placeholder="Confirm Password"
                style={inputStyle}
                name="confirmPassword"
                type="password"
                onChange={(e) =>
                  setAssistantData({
                    ...assistantData,
                    confirmPassword: e.target.value,
                  })
                }
                value={assistantData.confirmPassword}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleSubmitClient}
              variant="contained"
              style={{ marginRight: "25px" }}
            >
              Save Assistant
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
};

export default AddAssistant;
